import React from "react";
import { modulo8 } from "../../routes/Module8";
import Navlink from "../../components/Navlink";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="grade-name">{modulo8.grade.name} {'>'} {modulo8.module}</div>

      <h2>
        <strong>{modulo8.title}</strong>
      </h2>
      <div className={modulo8.color+'-effect'}>
        <Navlink url={"/" + modulo8.url} unidad>
          <h3 className={`c-${modulo8.color}`}>Inicio</h3>
        </Navlink>
        {modulo8.content.map((unidad, idx) => (
          <div key={idx}>
            {modulo8.content.length === 1 ? null : <h3 className={`c-${modulo8.color}`}>{unidad.name}</h3>}
            <div className="unidad">
              {unidad.activities.map((act, i) => (
                <div key={i}>
                  <Navlink url={`/${modulo8.url}/${unidad.path}/${act.path}`} color={modulo8.color}>
                    {act.name}
                  </Navlink>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
